import React from 'react';
import * as translator from '../../../../../utils/translator';
import { CareProfileEncouragement } from 'data-types';
import { careProfileAsset } from '../careProfileAssets';



interface EncouragementWidgetProps {
	encouragement: CareProfileEncouragement;
	language: string;
}

const titleGradient = 'linear-gradient(197.55deg, #ffb909 0.8%, #e17200 94.83%)';

const EncouragementWidget: React.FC<EncouragementWidgetProps> = ({ encouragement, language }) => {
	if (!encouragement.show) {
		return null;
	}

	const rawMessage = translator.translate(language, 'my_account', 'CareProfile/Encouragement/Message');
	const [messageBefore, messageAfter] = rawMessage.split('{{percent}}');

	return (
		<div
			id="encouragement-widget"
			className="flex flex-col w-full overflow-hidden rounded-[20px] border border-solid border-[rgba(255,185,9,0.4)] bg-[#faf4ef]"
		>
			<div id="encouragement-widget-text" className="flex flex-col gap-y-2 p-7 pb-4">
				<p
					className="bg-clip-text text-[28px] font-medium leading-[32px] text-transparent"
					style={{ backgroundImage: titleGradient }}
				>
					{translator.translate(language, 'my_account', 'CareProfile/Encouragement/Title')}
				</p>
				<p className="text-[18px] leading-[1.3] text-[#616975]">
					{messageBefore}
					<span className="font-medium text-[#e88103]">{encouragement.lostPercent}%</span>
					{messageAfter}
				</p>
			</div>

			<img
				id="encouragement-widget-image"
				src={careProfileAsset('couple-hero')}
				alt=""
				className="pointer-events-none w-full h-[240px] object-cover object-[25%_center]"
			/>
		</div>
	);
};

export default EncouragementWidget;
